__webpack_require__.p = "https://assets.coolblue.nl/_app/product-page-microfrontend/_next/";